module.exports = __webpack_public_path__ + "img/wallet-icon.d1d2d0ff.svg";